import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useTranslation } from "next-i18next";

interface StrategyLabApproachModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function StrategyLabApproachModal({
  isOpen,
  onOpenChange,
}: StrategyLabApproachModalProps) {
  const { t } = useTranslation("marketplace-page");

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg shadow-2xl p-6 md:p-8">
        <DialogHeader className="space-y-4">
          <DialogTitle className="text-xl font-bold text-center tracking-tight text-foreground md:text-2xl">
            {t("See How Popular Strategies Perform Under Prop Rules")}
          </DialogTitle>
          <DialogDescription className="text-base text-muted-foreground leading-relaxed text-center px-2 pt-2">
            <p className="mb-6">
              {t(
                "We backtest widely followed strategies from YouTube under prop firm evaluation conditions—so you can clearly see what works, what doesn’t, and why",
              )}
            </p>

            <div className="border-t border-border my-6" />

            <h3 className="text-lg font-bold text-foreground mb-3">
              {t("Will Your Strategy Pass a Prop Challenge?")}
            </h3>
            <p>
              {t(
                "Get an unbiased, data-backed evaluation using the same standardised testing conditions applied to every strategy. See its strengths, weaknesses, and whether it meets prop firm rules—before you risk real capital.",
              )}
            </p>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
